export interface Category {
  name: string;
  url: string;
  icon: string;
  imageSeq: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
    imageQuery: 'Stylish%20fashion%20sneakers%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20lifestyle%20shot%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail%2C%20harmonious%20composition%2C%20trendy%20footwear%20display',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies-02',
    imageQuery: 'Premium%20hoodie%20and%20sweater%20collection%20on%20soft%20cream%20backdrop%2C%20minimalist%20fashion%20photography%2C%20cozy%20aesthetic%2C%20warm%20ambient%20lighting%2C%20clean%20composition%2C%20streetwear%20style%2C%20textured%20fabric%20details%2C%20neutral%20warm%20tones',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    imageSeq: 'cat-tshirts-03',
    imageQuery: 'Premium%20t-shirt%20collection%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20clean%20folded%20presentation%2C%20soft%20natural%20lighting%2C%20casual%20fashion%20essentials%2C%20neutral%20warm%20aesthetic%2C%20high%20quality%20cotton%20texture%20visible',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-jackets-04',
    imageQuery: 'Stylish%20fashion%20jacket%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20elegant%20outerwear%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20premium%20fabric%20texture%2C%20modern%20fashion',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageSeq: 'cat-pants-05',
    imageQuery: 'Modern%20pants%20and%20shorts%20collection%20on%20warm%20cream%20background%2C%20minimalist%20fashion%20photography%2C%20clean%20product%20display%2C%20soft%20lighting%2C%20casual%20and%20formal%20styles%2C%20neutral%20aesthetic%2C%20contemporary%20fashion',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-5-line',
    imageSeq: 'cat-headwear-06',
    imageQuery: 'Trendy%20caps%20and%20headwear%20on%20soft%20cream%20background%2C%20minimalist%20product%20photography%2C%20clean%20display%2C%20streetwear%20aesthetic%2C%20warm%20natural%20lighting%2C%20modern%20style%2C%20fashion%20accessories',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-layout-grid-line',
    imageSeq: 'cat-sets-07',
    imageQuery: 'Coordinated%20fashion%20sets%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20matching%20outfits%20display%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20stylish%20ensembles%2C%20modern%20fashion%20collection',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    imageSeq: 'cat-underwear-08',
    imageQuery: 'Premium%20underwear%20basics%20on%20soft%20cream%20background%2C%20minimalist%20product%20photography%2C%20clean%20folded%20display%2C%20comfortable%20essentials%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20aesthetic%2C%20cotton%20fabric%20texture',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    imageQuery: 'Sports%20jersey%20collection%20on%20soft%20cream%20background%2C%20minimalist%20product%20photography%2C%20athletic%20wear%20display%2C%20clean%20composition%2C%20warm%20natural%20lighting%2C%20sportswear%20style%2C%20professional%20team%20aesthetic',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageSeq: 'cat-accessories-10',
    imageQuery: 'Fashion%20accessories%20collection%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20watches%20jewelry%20sunglasses%20display%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20elegant%20lifestyle%2C%20trendy%20style',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageSeq: 'cat-bags-11',
    imageQuery: 'Designer%20bags%20and%20handbags%20on%20soft%20cream%20background%2C%20minimalist%20product%20photography%2C%20elegant%20display%2C%20clean%20composition%2C%20warm%20natural%20lighting%2C%20luxury%20accessories%2C%20premium%20leather%20texture',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSeq: 'cat-belts-12',
    imageQuery: 'Premium%20leather%20belts%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20clean%20display%2C%20classic%20and%20modern%20styles%2C%20soft%20natural%20lighting%2C%20elegant%20fashion%20accessories%2C%20detailed%20buckle',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes-13',
    imageQuery: 'Elegant%20perfume%20bottles%20on%20soft%20cream%20background%2C%20minimalist%20product%20photography%2C%20luxury%20fragrance%20display%2C%20clean%20composition%2C%20warm%20natural%20lighting%2C%20sophisticated%20aesthetic%2C%20premium%20glass%20bottle%20details',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-14',
    imageQuery: 'Various%20lifestyle%20products%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20diverse%20items%20display%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20eclectic%20collection%2C%20trendy%20gadgets%20and%20goods',
  },
];